__turbopack_context__.v({
  "blok-big-title": "PopularSearches-module__21KqBW__blok-big-title",
  "blok-subtitle": "PopularSearches-module__21KqBW__blok-subtitle",
  "blok-title": "PopularSearches-module__21KqBW__blok-title",
  "root": "PopularSearches-module__21KqBW__root",
  "search": "PopularSearches-module__21KqBW__search",
});
